import { render, staticRenderFns } from "./BuilderPosterPopup.vue?vue&type=template&id=bd4830e8&scoped=true&"
import script from "./BuilderPosterPopup.vue?vue&type=script&lang=js&"
export * from "./BuilderPosterPopup.vue?vue&type=script&lang=js&"
import style0 from "./BuilderPosterPopup.vue?vue&type=style&index=0&id=bd4830e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4830e8",
  null
  
)

export default component.exports